























import { CreateElement, VNode } from 'vue';
import { Component, Prop } from 'vue-property-decorator';
import Chart, { ChartOptions } from 'chart.js';
import { SwExtendedVue } from '../sw-extended-vue';
import { utilService } from '../util-service';
import doughnutrounded from './chart-js-extensions/chartjs-plugin-doughnutrounded';
import staticlabel from './chart-js-extensions/chartjs-plugin-staticlabel';
const doughnutlabel = require('chartjs-plugin-doughnutlabel');
const streaming = require('chartjs-plugin-streaming');
require('chartjs-plugin-annotation');

const cssPrefix = 'sw-chart-chart-js-mixin';

/**
 * Note: Any charts using chart.js should use this mixin as the base, and shouldn't define
 * template or render() function again unless you know what you are doing.
 * Subclasses using this mixin also should not define `cssPrefix` any more.
 */
@Component
export default class SwChartChartJsMixin extends SwExtendedVue {
  @Prop(String)
  title: string;

  @Prop(String)
  caption: string;

  @Prop(Number)
  chartHeight: number;

  @Prop({ type: String, default: 'light' })
  theme: 'light' | 'dark';

  /** serves as leeway for overriding any options for any derived charts */
  @Prop({ type: Object, default: undefined })
  options: ChartOptions | undefined;

  myCssPrefix: string = '';

  protected chartInstance: Chart | null = null;

  protected initChart(config: Chart.ChartConfiguration) {
    if (!this.$refs.chartCanvas) {
      throw new Error('Cannot call initChart before the canvas has been rendered in the DOM.');
    }
    this.chartInstance = new Chart((this.$refs.chartCanvas as HTMLCanvasElement).getContext('2d')!, config);
  }

  public forceUpdate() {
    if (this.chartInstance) {
      this.chartInstance.update();
    }
  }

  get titleThemeStyle() {
    return this.theme === 'dark' ? `${cssPrefix}__title--dark` : '';
  }

  get captionThemeStyle() {
    return this.theme === 'dark' ? `${cssPrefix}__caption--dark` : '';
  }

  get textStyle() {
    return this.theme === 'dark' ? `${cssPrefix}--dark` : '';
  }

  private render(h: CreateElement): VNode {// tslint:disable-line
    let titleNode: VNode | null = null;
    let captionNode: VNode | null = null;

    if (this.title) {
      titleNode = (<div class={[`${cssPrefix}__title`, 'sw-flexbox__flex-none']}>{this.title}</div>) as VNode;
    }
    if (this.caption) {
      captionNode = (<div class={[`${cssPrefix}__caption`, 'sw-flexbox__flex-none']}>{this.caption}</div>) as VNode;
    }

    const rootNode = (
      <div class={[`${cssPrefix}`, this.textStyle, `${this.myCssPrefix}`, 'sw-typo-default', 'sw-flexbox', 'sw-flexbox--column']}>
        { titleNode }
        <div key="canvas-cont"
          class={[
            `${cssPrefix}__canvas-cont`,
            `${this.myCssPrefix}__canvas-cont`,
            !!this.chartHeight ? 'sw-flexbox__flex-none' : 'sw-flexbox__flex',
          ]}
          style={{
            height: !!this.chartHeight ? `${this.chartHeight}px` : undefined,
            flexBasis: !!this.chartHeight ? 'auto' : undefined, /** as `flex-basis` will have priority over `height` */
          }}
        >
          <canvas ref="chartCanvas"></canvas>
        </div>
        { captionNode }
      </div>
    );

    return rootNode as VNode;
  }

  protected updated() {
    if (this.chartInstance) {
      this.chartInstance.render();
    }
  }

  protected beforeDestroy() {
    if (this.chartInstance) {
      this.chartInstance.destroy();
      this.chartInstance = null;
    }
  }
}

/** Rest assured, this will run only once. */
(function initChartJsDefault() {
  Chart.defaults.global.responsive = true;
  Chart.defaults.global.responsiveAnimationDuration = 100;
  Chart.defaults.global.maintainAspectRatio = false;
  Chart.defaults.global.defaultFontFamily = 'Nunito, sans-serif';
  Chart.defaults.global.defaultFontSize = 13;
  Chart.defaults.global.defaultFontStyle = 'normal';
  Chart.defaults.global.defaultFontColor = utilService.colorConst.light_text;
  Chart.defaults.global.tooltips!.intersect = false;
  Chart.defaults.global.tooltips!.mode = 'nearest';
  Chart.defaults.global.tooltips!.cornerRadius = 3;
  Chart.defaults.global.animation!.duration = 500;

  Chart.plugins.register(doughnutlabel);
  Chart.plugins.register(doughnutrounded);
  Chart.plugins.register(streaming);
  Chart.plugins.register(staticlabel);

  /** side effected extensions */
  require('./chart-js-extensions/rounded-bar');
})();
